if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.submitButton.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const unitkey= Date.now();
        const fractionalProps = this.querySelector('.fractional_props');
        if(fractionalProps){          
          fractionalProps.value = unitkey;
        }

        // Check for fractional quantity BEFORE creating FormData
        // Find the quantity input with data-fractional="true"
        let quantityInput = null;
        let isFractional = false;
        
        // Search in product-info parent first, then in current form
        const productInfo = this.closest('product-info');
        if (productInfo) {
          const quantityInputWrap = productInfo.querySelector('.mf-quantity-input') || 
                                    productInfo.querySelector('quantity-input[data-fractional="true"]');
          if (quantityInputWrap) {
            isFractional = quantityInputWrap.getAttribute('data-fractional') === 'true';
            quantityInput = quantityInputWrap.querySelector('input[name="quantity"]');
          }
        }
        
        // If not found, search directly in form
        if (!quantityInput) {
          quantityInput = this.form.querySelector('input[name="quantity"][data-fractional="true"]') ||
                         this.form.querySelector('.quantity__input[data-fractional="true"]');
          if (quantityInput) {
            isFractional = quantityInput.getAttribute('data-fractional') === 'true';
          }
        }
        
        // Last resort: search all quantity inputs and find the one with fractional attribute
        if (!quantityInput || !isFractional) {
          const allQuantityInputs = this.form.querySelectorAll('input[name="quantity"]');
          for (let input of allQuantityInputs) {
            if (input.getAttribute('data-fractional') === 'true' || 
                input.closest('quantity-input')?.getAttribute('data-fractional') === 'true') {
              quantityInput = input;
              isFractional = true;
              break;
            }
          }
        }

        let cartQuantity = null;
        let fractionalValue = null;

        if(isFractional && quantityInput){
          fractionalValue = parseFloat(quantityInput.value);
          
          if (!isNaN(fractionalValue) && fractionalValue > 0) {
            // Get step value from input attribute (e.g., 0.5 for Unit_50, 0.25 for Unit_25)
            const step = parseFloat(quantityInput.getAttribute('step')) || parseFloat(quantityInput.step) || 0.5;
            
            // Convert fractional quantity to integer for Shopify cart API
            // Shopify Cart API requires integer quantities
            // For Unit_50 (step 0.5): 2.5 / 0.5 = 5
            // For Unit_25 (step 0.25): 1.5 / 0.25 = 6
            cartQuantity = Math.round(fractionalValue / step);
            
            // Update total_yardage property with the actual fractional value
            const totalYardageInput = this.form.querySelector('#total_fractional_yard');
            if(totalYardageInput) {
              totalYardageInput.value = fractionalValue.toString();
            }
            
            console.log('✅ Fractional quantity conversion:', {
              fractionalValue: fractionalValue,
              step: step,
              cartQuantity: cartQuantity,
              quantityInputId: quantityInput.id,
              calculation: `${fractionalValue} / ${step} = ${cartQuantity}`
            });
          }
        }

        // Create FormData AFTER updating hidden fields
        const formData = new FormData(this.form);
        
        // CRITICAL: Override quantity if fractional (this ensures correct quantity is sent to Shopify)
        // Remove existing quantity entry and add new one
        if(isFractional && cartQuantity !== null && cartQuantity > 0) {
          // Delete all quantity entries first (in case there are multiple)
          formData.delete('quantity');
          // Then set the converted quantity
          formData.append('quantity', cartQuantity.toString());
          
          console.log('✅ Fractional quantity override:', {
            originalValue: fractionalValue,
            step: parseFloat(quantityInput?.getAttribute('step')) || 0.5,
            convertedQuantity: cartQuantity,
            formDataQuantity: formData.get('quantity')
          });
        } else {
          const defaultQuantity = formData.get('quantity');
          console.log('⚠️ Not using fractional conversion:', { 
            isFractional, 
            cartQuantity, 
            foundInput: !!quantityInput,
            defaultQuantity: defaultQuantity,
            inputValue: quantityInput?.value 
          });
        }
        
        // Debug: Verify what's being sent
        console.log('📦 Final Cart Add Request Data:', {
          quantity: formData.get('quantity'),
          variantId: formData.get('id'),
          total_yardage: formData.get('properties[total_yardage]'),
          allQuantities: formData.getAll('quantity') // Debug: Check if multiple quantities exist
        });


        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.classList.add('added');
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.submitButton.querySelector('.loading__spinner').classList.add('hidden');
            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
